import { Grid, Typography } from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import React, { useEffect, useRef, useState } from 'react'
import { onEditAction } from '../../core/audit'
import {
  auditColumn,
  CollectionTable,
  Column,
  deleteColumn,
  editColumn,
  FilterControl,
  shimColumn,
} from '../../core/collections'
import { Auto, Text } from '../../core/controls'
import { Expansion, ExpansionDetails, ExpansionSummary } from '../../core/expansion'
import { truncateSpan } from '../../core/format'
import { ReviewQuestionApi } from '../../core/review-question-api'
import { orange } from '../../core/theme'
import { UndoRedo } from '../../core/undo-redo'
import { isAuditReviewWorkflow,isReviewWorkflow } from '../../core/workflow-api'
import { isResolved } from '../../core/worksheets'
import { formatDate, utcDateString } from '../../core'

export function ReviewQuestionForm(api: ReviewQuestionApi) {
  const form = useRef(api.form).current
  const { reason, question, reply } = form.controls

  return (
    <Grid
      container
      item
      xs={12}
      spacing={2}
      style={{
        width: '100%',
        paddingLeft: '12px',
        paddingTop: '6px',
        paddingBottom: '8px',
      }}
    >
      <Grid item xs={3}>
        <Auto {...reason} />
      </Grid>
      <Grid item xs={4}>
        <Text {...question} />
      </Grid>
      <Grid item xs={5}>
        <Text {...reply} />
      </Grid>
    </Grid>
  )
}

function reviewDescription(e) {
  let label = formatDate(utcDateString(e.createDate), 'MM/dd/yyyy') + ' - '
  return label + e.description
}

export function ReviewQuestionCollection(api: ReviewQuestionApi) {
  const { list, context } = api
  const { auditDownCode } = context.config

  const isReview = isAuditReviewWorkflow()
  const actions = isReview
    ? [auditColumn(onEditAction('Edit Downcode Audit Comments', () => list.actions.refresh(), false, auditDownCode))]
    : []

  const columns: Column[] = [
    {
      name: 'description',
      label: 'Reason',
      component: (e) => truncateSpan(reviewDescription(e.value), '80px'),
    },
    {
      name: 'question',
      label: 'Question',
      component: (e) => truncateSpan(e.value.question, '80px'),
    },
    {
      name: 'reply',
      component: (e) => truncateSpan(e.value.reply, '35vw'),
      label: 'Reply',
    },
    ...actions,
    editColumn(
      (e) => api.editItem(e.value),
      (v) => !isResolved(v),
    ),
    deleteColumn(
      (e) => api.removeItem(e.value),
      (v) => !isResolved(v),
    ),
    shimColumn(),
  ]

  const values = list.data((s) => s.values)
  const [expanded, setExpanded] = useState(values.length > 0)
  const [clicked, setClicked] = useState(false)

  useEffect(() => {
    if (!clicked && !expanded) {
      setExpanded(values.length > 0)
    }
  })

  const onClicked = () => {
    setExpanded(!expanded)
    setClicked(true)
  }

  return (
    <Expansion expanded={expanded}>
      <ExpansionSummary onClick={onClicked} expandIcon={<ExpandMoreIcon id="review_questions_expend_more" />}>
        <div
          style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            gap: 24,
            alignItems: 'center',
            flexWrap: 'nowrap',
          }}
        >
          <Typography variant="subtitle2">{`REVIEW QUESTIONS ${values.length ? '- ' + values.length : ''}`}</Typography>
          <div style={{ display: 'flex', flex: 1, flexGrow: 1 }} />

          <div onClick={(e) => e.stopPropagation()}>
            <UndoRedo api={api.listChanges} htmlColor={orange} label="review-questions" />
          </div>

          <FilterControl api={list} />
        </div>
      </ExpansionSummary>
      <ExpansionDetails>
        <CollectionTable
          readonly={api.context.readonly}
          columns={columns}
          api={list}
          containerProps={{ elevation: 0 }}
          name="review-questions-table"
          label={`REVIEW QUESTIONS ${values.length ? '- ' + values.length : ''}`}
        />
      </ExpansionDetails>
    </Expansion>
  )
}
